import Vue from "vue"
import Vuex from "vuex"
import createPersitedState from "vuex-persistedstate"
import { article } from "@/store/article"
import { adminUser } from "@/store/adminUser"
import { master } from "./store/master"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    article,
    adminUser,
    master,
  },
  state: {
    authToken: null,
  },
  getters: {},
  mutations: {
    updateAuthToken(state, payload) {
      state.authToken = payload
    },
  },
  actions: {
    login({ commit }, payload) {
      commit("updateAuthToken", payload.authToken)
      commit("adminUser/updateAdminUser", payload.adminUser)
    },
    logout({ commit }) {
      commit("updateAuthToken", null)
      commit("adminUser/initAdminUser", null)
      commit("article/initArticle", null)
    },
  },
  plugins: [
    createPersitedState({
      key: "authToken",
      paths: ["authToken"],
      storage: window.localStorage,
    }),
  ],
})
